export const OptionsToConnect = [
  { id: 0, label: 'Local Engine', formFields: ['Engine WebSocket URL'] },
  { id: 1, label: 'Web Integration Id', formFields: ['Engine WebSocket URL', 'Web Integration Id'] },
  { id: 2, label: 'Client Id', formFields: ['Engine WebSocket URL', 'Client Id'] },
];
